export enum Permission {
  ACCESS_TO_ADMIN_PANEL = 'ACCESS_TO_ADMIN_PANEL',
  SHOP_CAN_BANNER_CREATE = 'SHOP_CAN_BANNER_CREATE',
  SHOP_CAN_BANNER_DELETE = 'SHOP_CAN_BANNER_DELETE',
  SHOP_CAN_BANNER_LIST = 'SHOP_CAN_BANNER_LIST',
  SHOP_CAN_BANNER_UPDATE = 'SHOP_CAN_BANNER_UPDATE',
  SHOP_CAN_BANNER_VIEW = 'SHOP_CAN_BANNER_VIEW',
  SHOP_CAN_BOX_CATEGORY_CREATE = 'SHOP_CAN_BOX_CATEGORY_CREATE',
  SHOP_CAN_BOX_CATEGORY_DELETE = 'SHOP_CAN_BOX_CATEGORY_DELETE',
  SHOP_CAN_BOX_CATEGORY_LIST = 'SHOP_CAN_BOX_CATEGORY_LIST',
  SHOP_CAN_BOX_CATEGORY_UPDATE = 'SHOP_CAN_BOX_CATEGORY_UPDATE',
  SHOP_CAN_BOX_CATEGORY_VIEW = 'SHOP_CAN_BOX_CATEGORY_VIEW',
  SHOP_CAN_BOX_CREATE = 'SHOP_CAN_BOX_CREATE',
  SHOP_CAN_BOX_QUESTIONNAIRE_LIST = 'SHOP_CAN_BOX_QUESTIONNAIRE_LIST',
  SHOP_CAN_BOX_QUESTIONNAIRE_VIEW = 'SHOP_CAN_BOX_QUESTIONNAIRE_VIEW',
  SHOP_CAN_BOX_SALE_HIDE_CONTENT = 'SHOP_CAN_BOX_SALE_HIDE_CONTENT',
  SHOP_CAN_BOX_SALE_LIST = 'SHOP_CAN_BOX_SALE_LIST',
  SHOP_CAN_BOX_SALE_PUBLIC_CONTENT = 'SHOP_CAN_BOX_SALE_PUBLIC_CONTENT',
  SHOP_CAN_BOX_SALE_UPDATE = 'SHOP_CAN_BOX_SALE_UPDATE',
  SHOP_CAN_BOX_SALE_VIEW = 'SHOP_CAN_BOX_SALE_VIEW',
  SHOP_CAN_BOX_LIST = 'SHOP_CAN_BOX_LIST',
  SHOP_CAN_BOX_UPDATE = 'SHOP_CAN_BOX_UPDATE',
  SHOP_CAN_BOX_VIEW = 'SHOP_CAN_BOX_VIEW',
  SHOP_CAN_BOX_WAREHOUSE_GOOD_UPDATE = 'SHOP_CAN_BOX_WAREHOUSE_GOOD_UPDATE',
  SHOP_CAN_COSMETIC_BRAND_CREATE = 'SHOP_CAN_COSMETIC_BRAND_CREATE',
  SHOP_CAN_COSMETIC_BRAND_DELETE = 'SHOP_CAN_COSMETIC_BRAND_DELETE',
  SHOP_CAN_COSMETIC_BRAND_LIST = 'SHOP_CAN_COSMETIC_BRAND_LIST',
  SHOP_CAN_COSMETIC_BRAND_UPDATE = 'SHOP_CAN_COSMETIC_BRAND_UPDATE',
  SHOP_CAN_COSMETIC_BRAND_VIEW = 'SHOP_CAN_COSMETIC_BRAND_VIEW',
  SHOP_CAN_COSMETIC_CREATE = 'SHOP_CAN_COSMETIC_CREATE',
  SHOP_CAN_COSMETIC_DELETE = 'SHOP_CAN_COSMETIC_DELETE',
  SHOP_CAN_COSMETIC_LIST = 'SHOP_CAN_COSMETIC_LIST',
  SHOP_CAN_COSMETIC_UPDATE = 'SHOP_CAN_COSMETIC_UPDATE',
  SHOP_CAN_COSMETIC_VIEW = 'SHOP_CAN_COSMETIC_VIEW',
  SHOP_CAN_COSMETIC_WAREHOUSE_GOOD_UPDATE = 'SHOP_CAN_COSMETIC_WAREHOUSE_GOOD_UPDATE',
  SHOP_CAN_COUNTRY_CREATE = 'SHOP_CAN_COUNTRY_CREATE',
  SHOP_CAN_COUNTRY_DELETE = 'SHOP_CAN_COUNTRY_DELETE',
  SHOP_CAN_COUNTRY_LIST = 'SHOP_CAN_COUNTRY_LIST',
  SHOP_CAN_COUNTRY_UPDATE = 'SHOP_CAN_COUNTRY_UPDATE',
  SHOP_CAN_COUNTRY_VIEW = 'SHOP_CAN_COUNTRY_VIEW',
  SHOP_CAN_INVOICE_LIST = 'SHOP_CAN_INVOICE_LIST',
  SHOP_CAN_SETTINGS_MANAGE_INVOICE = 'SHOP_CAN_SETTINGS_MANAGE_INVOICE',
  SHOP_CAN_SETTINGS_MANAGE_REFUND = 'SHOP_CAN_SETTINGS_MANAGE_REFUND',
  SHOP_CAN_SETTINGS_MANAGE_SHIPPING = 'SHOP_CAN_SETTINGS_MANAGE_SHIPPING',
  SHOP_CAN_SETTINGS_MANAGE_VALIDATION = 'SHOP_CAN_SETTINGS_MANAGE_VALIDATION',
  SHOP_CAN_SETTINGS_MANAGE_CART = 'SHOP_CAN_SETTINGS_MANAGE_CART',
  SHOP_CAN_BACKGROUND_TASK_LIST = 'SHOP_CAN_BACKGROUND_TASK_LIST',
  SHOP_CAN_ORDER_LIST = 'SHOP_CAN_ORDER_LIST',
  SHOP_CAN_ORDER_REFUND = 'SHOP_CAN_ORDER_REFUND',
  SHOP_CAN_ORDER_VIEW = 'SHOP_CAN_ORDER_VIEW',
  SHOP_CAN_PAGE_CREATE = 'SHOP_CAN_PAGE_CREATE',
  SHOP_CAN_PAGE_DELETE = 'SHOP_CAN_PAGE_DELETE',
  SHOP_CAN_PAGE_LIST = 'SHOP_CAN_PAGE_LIST',
  SHOP_CAN_PAGE_UPDATE = 'SHOP_CAN_PAGE_UPDATE',
  SHOP_CAN_PAGE_VIEW = 'SHOP_CAN_PAGE_VIEW',
  SHOP_CAN_FAQ_CATEGORY_LIST = 'SHOP_CAN_FAQ_CATEGORY_LIST',
  SHOP_CAN_FAQ_CATEGORY_VIEW = 'SHOP_CAN_FAQ_CATEGORY_VIEW',
  SHOP_CAN_FAQ_CATEGORY_CREATE = 'SHOP_CAN_FAQ_CATEGORY_CREATE',
  SHOP_CAN_FAQ_CATEGORY_UPDATE = 'SHOP_CAN_FAQ_CATEGORY_UPDATE',
  SHOP_CAN_FAQ_CATEGORY_DELETE = 'SHOP_CAN_FAQ_CATEGORY_DELETE',
  SHOP_CAN_PAYMENT_METHOD_LIST = 'SHOP_CAN_PAYMENT_METHOD_LIST',
  SHOP_CAN_PAYMENT_METHOD_UPDATE = 'SHOP_CAN_PAYMENT_METHOD_UPDATE',
  SHOP_CAN_PAYMENT_METHOD_VIEW = 'SHOP_CAN_PAYMENT_METHOD_VIEW',
  SHOP_CAN_PRODUCT_ATTRIBUTE_CREATE = 'SHOP_CAN_PRODUCT_ATTRIBUTE_CREATE',
  SHOP_CAN_PRODUCT_ATTRIBUTE_DELETE = 'SHOP_CAN_PRODUCT_ATTRIBUTE_DELETE',
  SHOP_CAN_PRODUCT_ATTRIBUTE_LIST = 'SHOP_CAN_PRODUCT_ATTRIBUTE_LIST',
  SHOP_CAN_PRODUCT_ATTRIBUTE_UPDATE = 'SHOP_CAN_PRODUCT_ATTRIBUTE_UPDATE',
  SHOP_CAN_PRODUCT_ATTRIBUTE_VIEW = 'SHOP_CAN_PRODUCT_ATTRIBUTE_VIEW',
  SHOP_CAN_PRODUCT_CREATE = 'SHOP_CAN_PRODUCT_CREATE',
  SHOP_CAN_PRODUCT_DELETE = 'SHOP_CAN_PRODUCT_DELETE',
  SHOP_CAN_PRODUCT_LIST = 'SHOP_CAN_PRODUCT_LIST',
  SHOP_CAN_PRODUCT_UPDATE = 'SHOP_CAN_PRODUCT_UPDATE',
  SHOP_CAN_PRODUCT_VIEW = 'SHOP_CAN_PRODUCT_VIEW',
  SHOP_CAN_SHIPPING_METHOD_LIST = 'SHOP_CAN_SHIPPING_METHOD_LIST',
  SHOP_CAN_SHIPPING_METHOD_UPDATE = 'SHOP_CAN_SHIPPING_METHOD_UPDATE',
  SHOP_CAN_SHIPPING_METHOD_VIEW = 'SHOP_CAN_SHIPPING_METHOD_VIEW',
  SHOP_CAN_SUBSCRIPTION_BULK_PRICE_CHANGE = 'SHOP_CAN_SUBSCRIPTION_BULK_PRICE_CHANGE',
  SHOP_CAN_SUBSCRIPTION_CANCEL = 'SHOP_CAN_SUBSCRIPTION_CANCEL',
  SHOP_CAN_SUBSCRIPTION_LIST = 'SHOP_CAN_SUBSCRIPTION_LIST',
  SHOP_CAN_SUBSCRIPTION_UPDATE = 'SHOP_CAN_SUBSCRIPTION_UPDATE',
  SHOP_CAN_SUBSCRIPTION_VIEW = 'SHOP_CAN_SUBSCRIPTION_VIEW',
  SSO_CAN_COMPANY_CREATE = 'SSO_CAN_COMPANY_CREATE',
  SSO_CAN_COMPANY_LIST = 'SSO_CAN_COMPANY_LIST',
  SSO_CAN_COMPANY_UPDATE = 'SSO_CAN_COMPANY_UPDATE',
  SSO_CAN_COMPANY_VIEW = 'SSO_CAN_COMPANY_VIEW',
  SSO_CAN_USER_ACTIVATE = 'SSO_CAN_USER_ACTIVATE',
  SSO_CAN_USER_CREATE = 'SSO_CAN_USER_CREATE',
  SSO_CAN_USER_DELETE = 'SSO_CAN_USER_DELETE',
  SSO_CAN_USER_LIST = 'SSO_CAN_USER_LIST',
  SSO_CAN_USER_SEND_ACTIVATION_MESSAGE = 'SSO_CAN_USER_SEND_ACTIVATION_MESSAGE',
  SSO_CAN_USER_UPDATE = 'SSO_CAN_USER_UPDATE',
  SSO_CAN_USER_VIEW = 'SSO_CAN_USER_VIEW',
  STORAGE_CAN_SHOP_FILE_DELETE = 'STORAGE_CAN_SHOP_FILE_DELETE',
  STORAGE_CAN_SHOP_FILE_LIST = 'STORAGE_CAN_SHOP_FILE_LIST',
  STORAGE_CAN_SHOP_FILE_UPDATE = 'STORAGE_CAN_SHOP_FILE_UPDATE',
  STORAGE_CAN_SHOP_FILE_UPLOAD = 'STORAGE_CAN_SHOP_FILE_UPLOAD',
  STORAGE_CAN_SHOP_FILE_VIEW = 'STORAGE_CAN_SHOP_FILE_VIEW',
  STORAGE_CAN_WAREHOUSE_FILE_UPLOAD = 'STORAGE_CAN_WAREHOUSE_FILE_UPLOAD',
  STORAGE_CAN_WAREHOUSE_FILE_VIEW = 'STORAGE_CAN_WAREHOUSE_FILE_VIEW',
  NOTIFIER_CAN_NOTIFICATION_LIST = 'NOTIFIER_CAN_NOTIFICATION_LIST',
  NOTIFIER_CAN_NOTIFICATION_VIEW = 'NOTIFIER_CAN_NOTIFICATION_VIEW',
  WAREHOUSE_CAN_DOWNLOAD_GOOD_QUANTITY_REPORT = 'WAREHOUSE_CAN_DOWNLOAD_GOOD_QUANTITY_REPORT',
  WAREHOUSE_CAN_GOOD_DOWNLOAD_LABEL = 'WAREHOUSE_CAN_GOOD_DOWNLOAD_LABEL',
  WAREHOUSE_CAN_GOOD_LIST = 'WAREHOUSE_CAN_GOOD_LIST',
  WAREHOUSE_CAN_GOOD_UPDATE = 'WAREHOUSE_CAN_GOOD_UPDATE',
  WAREHOUSE_CAN_GOOD_VIEW = 'WAREHOUSE_CAN_GOOD_VIEW',
  WAREHOUSE_CAN_LOCALISATION_CREATE = 'WAREHOUSE_CAN_LOCALISATION_CREATE',
  WAREHOUSE_CAN_LOCALISATION_DELETE = 'WAREHOUSE_CAN_LOCALISATION_DELETE',
  WAREHOUSE_CAN_LOCALISATION_LIST = 'WAREHOUSE_CAN_LOCALISATION_LIST',
  WAREHOUSE_CAN_LOCALISATION_UPDATE = 'WAREHOUSE_CAN_LOCALISATION_UPDATE',
  WAREHOUSE_CAN_LOCALISATION_VIEW = 'WAREHOUSE_CAN_LOCALISATION_VIEW',
  WAREHOUSE_CAN_OWNER_LIST = 'WAREHOUSE_CAN_OWNER_LIST',
  WAREHOUSE_CAN_OWNER_VIEW = 'WAREHOUSE_CAN_OWNER_VIEW',
  WAREHOUSE_CAN_RECEIPT_APPROVE = 'WAREHOUSE_CAN_RECEIPT_APPROVE',
  WAREHOUSE_CAN_RECEIPT_CREATE = 'WAREHOUSE_CAN_RECEIPT_CREATE',
  WAREHOUSE_CAN_RECEIPT_LIST = 'WAREHOUSE_CAN_RECEIPT_LIST',
  WAREHOUSE_CAN_RECEIPT_UPDATE = 'WAREHOUSE_CAN_RECEIPT_UPDATE',
  WAREHOUSE_CAN_RECEIPT_VIEW = 'WAREHOUSE_CAN_RECEIPT_VIEW',
  WAREHOUSE_CAN_RELEASE_APPROVE = 'WAREHOUSE_CAN_RELEASE_APPROVE',
  WAREHOUSE_CAN_RELEASE_CREATE = 'WAREHOUSE_CAN_RELEASE_CREATE',
  WAREHOUSE_CAN_RELEASE_LIST = 'WAREHOUSE_CAN_RELEASE_LIST',
  WAREHOUSE_CAN_RELEASE_UPDATE = 'WAREHOUSE_CAN_RELEASE_UPDATE',
  WAREHOUSE_CAN_RELEASE_VIEW = 'WAREHOUSE_CAN_RELEASE_VIEW',
  WAREHOUSE_CAN_RESTOCK_APPROVE = 'WAREHOUSE_CAN_RESTOCK_APPROVE',
  WAREHOUSE_CAN_RESTOCK_CREATE = 'WAREHOUSE_CAN_RESTOCK_CREATE',
  WAREHOUSE_CAN_RESTOCK_LIST = 'WAREHOUSE_CAN_RESTOCK_LIST',
  WAREHOUSE_CAN_RESTOCK_REJECT = 'WAREHOUSE_CAN_RESTOCK_REJECT',
  WAREHOUSE_CAN_RESTOCK_UPDATE = 'WAREHOUSE_CAN_RESTOCK_UPDATE',
  WAREHOUSE_CAN_RESTOCK_VIEW = 'WAREHOUSE_CAN_RESTOCK_VIEW',
}
